import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { Gantt, GanttColumn, GanttView } from '@progress/kendo-gantt-vue-wrapper';
import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue';
import { OptimizeCorporateScenarioScheduleCommandV1 } from '@Quest/CorporateScenarios/Domain/commands-core';
import CorporateScenariosCommands from '@Quest/CorporateScenarios/Domain/commands-vue-component';
import CorporateScenariosQueries from '@Quest/CorporateScenarios/Domain/queries-vue-component';
import { ScenarioItemReadModel, SchedulingPageReadModel } from '@Quest/CorporateScenarios/Domain/readmodels';
import { ICommandBase } from '@Quest/cqrs';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        CorporateNavigation, ScenarioNavigation,
        'gantt': Gantt, 'gantt-view': GanttView, 'gantt-column': GanttColumn,
    }
})
export default class SchedulingPage extends mixins(CorporateScenariosCommands, CorporateScenariosQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: SchedulingPageReadModel | null = null;

    searchPhrase: string | null = null;

    get projectsView(): ScenarioItemReadModel[]
    {
        let view = new Array(...this.rm!.Items);

        if (this.searchPhrase)
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1);
        }

        return view;
    }


    get ds()
    {
        if (!this.rm) return null;

        const view = this.projectsView.filter(a => a.StartDate && a.EndDate).map(a => 
        {
            const start = new Date(a.StartDate!);
            const end = new Date(a.EndDate!);

            return {
                id: a.Id,
                title: a.Name,
                start: start,
                end: end,
            };
        });

        return view;
    }

    get dataSource()
    {
        return new kendo.data.GanttDataSource({
            data: this.ds
        });
    }

    edit(e: any)
    {
        const selection = e.sender.select();
        const task = e.sender.dataItem(selection);
        //const alternative = this.rm!.Items.find(a => a.Id === task.id);

        //emit
        //this.schedulingForm.show(alternative);

        //const selection = e.sender.select();
        //const task = e.sender.dataItem(selection);

        //if (this.selectedId === task.id)
        //{
        //    const alternative = this.alternatives.find(a => a.rm.AlternativeId === this.selectedId);
        //    this.schedulingForm.show(alternative);
        //}
        //else
        //{
        //    this.selectedId = task.id;
        //}
    }

    mounted()
    {
        document.title = "Enterprise Plan - Schedule";
        this.runSchedulingPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "SchedulingPageReadModel")
        {
            this.rm = model as SchedulingPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (OptimizeCorporateScenarioScheduleCommandV1.matchType(cmd))
        {
            this.runSchedulingPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
        }
    }
}